'use strict';

import { GLOBAL } from './Global';
import { INTRANET as INTRANET_PERMISSION_GROUPS } from '../PermissionsGroups';

const intranet_permissions_list = [];

for (const [key, value] of Object.entries(INTRANET_PERMISSION_GROUPS)) {
  intranet_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const INTRANET = {
  can: [
    ...GLOBAL.can,
    ...intranet_permissions_list,
  ],
};

export {
  INTRANET,
};
